import { LoanProductLandingScreen } from "@/screens/prequal/LoanProductLandingScreen"

export default function LoanProductLandingPage() {
  return <LoanProductLandingScreen />
}
